import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { UserModule } from '®shared/user';

import { ReadingListModule } from '../models';

import { ReadingListMetadataService } from './reading-list-metadata.service';

@NgModule({
  imports: [CommonModule, ReadingListModule, UserModule],
  providers: [ReadingListMetadataService],
})
export class ReadingListMetadataModule {}
